// extracted by mini-css-extract-plugin
export var article = "TeamItem-module--article--75628";
export var content = "TeamItem-module--content--bee58";
export var heading = "TeamItem-module--heading--db813";
export var image = "TeamItem-module--image--841a8";
export var isReversed = "TeamItem-module--isReversed--38257";
export var paragraph = "TeamItem-module--paragraph--7ebd2";
export var picture = "TeamItem-module--picture--a7839";
export var subheading = "TeamItem-module--subheading--45708";